import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";
import { sendReaderEvent } from "@/lib/readerEvents";
import { useLang } from "@/lib/i18n";

// Icon-only pill switch (sun / moon): outer height follows --ctl-h (40px pointer / 50px touch),
// knob slides in 180ms (none under reduced motion). Selected mode = highlighted icon + aria-checked.
export default function ThemeToggle({ className = "" }) {
    const { theme, toggle } = useTheme();
    const { lang } = useLang();
    const isDark = theme === "dark";
    // aria-label/title describe the ACTION the button performs; sr-only text announces the current state.
    const label = lang !== "ar" ? (isDark ? "Enable day mode" : "Enable night mode") : (isDark ? "تفعيل الوضع النهاري" : "تفعيل الوضع الليلي");
    const current = lang !== "ar" ? (isDark ? "Current: night mode" : "Current: day mode") : (isDark ? "الوضع الحالي: الليلي" : "الوضع الحالي: النهاري");
    return (
        <span className={`beam-ring beam-ring--slow rounded-full topbar-ctl ${className}`} data-testid="theme-toggle-beam">
            <button
                type="button"
                role="switch"
                aria-checked={isDark}
                onClick={() => { toggle(); sendReaderEvent("theme_change", { target: theme === "dark" ? "dark>light" : "light>dark" }); }}
                aria-label={label}
                title={label}
                className="theme-pill glow-target relative inline-flex items-center shrink-0 cursor-pointer rounded-full"
                data-testid="theme-toggle"
                data-theme-state={theme}
            >
                <span className="sr-only">{current}</span>
                <span className="theme-pill-track absolute rounded-full" aria-hidden="true" />
                <span className={`theme-pill-knob absolute rounded-full ${isDark ? "theme-pill-knob--dark" : "theme-pill-knob--light"}`} aria-hidden="true" />
                <span className="relative z-10 flex w-full items-center justify-between theme-pill-icons" aria-hidden="true">
                    <Sun className={`theme-pill-icon ${isDark ? "" : "theme-pill-icon--on"}`} />
                    <Moon className={`theme-pill-icon ${isDark ? "theme-pill-icon--on" : ""}`} />
                </span>
            </button>
        </span>
    );
}
